import React from "react";
import VerticalPage from "@/verticals/VerticalPage";
import { commerceData } from "@/verticals/verticalData";

export default function CommercePage() {
  return <VerticalPage data={commerceData} />;
}
